import { HttpAdapter } from "../../../main/adapters/HttpAdapter";

export class AwsSnsAdapter {
    HttpAdapter = new HttpAdapter();
    baseUrlDataCommunications = `${publicSettings.aws.baseUrls.dataCommunications}/data-communications`;

    constructor() {}

    async publish(topicArn, message, subject) {
        if (!topicArn) throw new Error("topicArn required.");
        if (typeof topicArn !== "string")
            throw new Error("invalid format topicArn. should be string.");
        if (!message) throw new Error("message required.");
        if (typeof message !== "string")
            throw new Error("invalid format message. should be string.");
        const params = {
            TopicArn: topicArn,
            Message: message,
            Subject: subject,
            MessageAttributes: {
                environment: {
                    DataType: "String",
                    StringValue: publicSettings.environment
                }
            }
        };
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataCommunications}/send-notification-topic`,
                params
            );
            return response;
        } catch (error) {
            console.error(error, error.stack);
        }
    }
}
